import { NEW_TAB_HINT } from '@/content/a11y-ui';

/**
 * Visually hidden "(opens in a new tab)" suffix for `target="_blank"` links,
 * so screen-reader users are told before the context changes (WCAG 3.2.5
 * advisory, G201). Place it as the last child of the link: it extends the
 * accessible name without breaking label-in-name (2.5.3).
 */
export function NewTabHint(): React.JSX.Element {
  return <span className="sr-only"> {NEW_TAB_HINT}</span>;
}
